import React from 'react';
import './styleDiognal.css';
import Dropzone from 'react-dropzone';
import uniqid from 'uniqid';
import Webcam from 'react-webcam';
import { Close } from '@mui/icons-material';
import { Button } from '@mui/material';

import { useDispatch, useSelector } from 'react-redux';

import { setAlertWithTitle } from '../../Redux/modal';
import { UploadFile, deleteFile } from '../../functions/firebase';
import { selectPrefix } from '../../Redux/profile';
const ProfilePicFrame = ({
  customerFirebasePic,
  selectedFile,
  setSelectedFile,
  webcamStatus,
  setWebcamStatus,
  capturedImage,
  setCapturedImage,
  webcamRef,
  path,
  setFirebaseUrl,
}) => {
  const customerDetails = {
    mobile: '123',
  };
  const prefix = useSelector(selectPrefix);
  const dispatch = useDispatch();
  const handleDrop = (acceptedFiles) => {
    if (customerDetails?.mobile) {
      const editedFiles = acceptedFiles.map((file) => {
        const editedName = ` ${uniqid()}-${file.name}`;
        return new File([file], editedName, { type: file.type });
      });

      setSelectedFile(editedFiles[0]);

      const name = `${prefix + customerDetails.mobile}`;
      const path = 'rootbilling/images/';
      UploadFile(editedFiles[0], path, name);
    } else {
      dispatch(
        setAlertWithTitle({
          title: 'Customer Mobile!',
          msg: 'Please select Customer Mobile to continue.',
        })
      );
    }

    // dispatch(setSelectedPhoto(acceptedFiles[0]));
  };
  const shootImage = async () => {
    const imageSrc = webcamRef.current.getScreenshot();

    setCapturedImage(imageSrc);
    const name = `${prefix + customerDetails.mobile}`;
    const path = 'rootbilling/images/';
    const file = await fetch(imageSrc).then((response) => response.blob());
    UploadFile(file, path, name);
    setWebcamStatus(false);
  };
  return (
    <div
      style={{
        height: '100%',
        width: '100%',
      }}
      className="diagonalp-container p-2  rounded-sm"
    >
      {webcamStatus ? (
        <div className="h-full w-full flex flex-col justify-between">
          <Close
            onClick={() => {
              setWebcamStatus(false);
              setSelectedFile('');
            }}
            style={{
              position: 'absolute',
              top: '0',
              right: '0',
              color: '#8A8787',
              backgroundColor: '#ebd9dd',
              zIndex: '50',
              borderBottomLeftRadius: '7px',
              borderTopRightRadius: '7px',
              fontSize: '17px',
            }}
          />
          <Webcam
            audio={false}
            ref={webcamRef}
            style={{
              width: '100%', // Set your desired width
              height: 'auto',
            }}
            // height={profilePicWidth - 50}
            mirrored={true} // Depending on your preference
          />
          <Button
            // ref={updateRef}
            onClick={() => {
              shootImage();
            }}
            variant="contained"
            size="small"
            style={{
              textTransform: 'none',
              letterSpacing: '1px',
              backgroundColor: '#ebd9dd',
              width: '100%',

              fontWeight: '500',

              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <div className="text-black  flex flex-col  ">Save Image </div>
          </Button>
        </div>
      ) : capturedImage ? (
        <div className="h-full w-full  ">
          <Button
            sx={{
              position: 'absolute',
              top: '0',
              right: '0',
              padding: 0,
            }}
          >
            <Close
              onClick={() => {
                setCapturedImage(null);
              }}
              style={{
                position: 'absolute',
                top: '0',
                right: '0',
                color: '#8A8787',
                backgroundColor: '#ebd9dd',
                zIndex: '50',
                borderBottomLeftRadius: '7px',
                borderTopRightRadius: '7px',
                fontSize: '17px',
              }}
            />
          </Button>

          <img
            src={capturedImage}
            alt={`Selected`}
            style={{
              width: 'auto',
              height: '100%',
            }}
          />
        </div>
      ) : selectedFile ? (
        <div className="h-full w-full">
          <Close
            onClick={() => {
              setWebcamStatus(false);
              setSelectedFile('');
            }}
            style={{
              position: 'absolute',
              top: '0',
              right: '0',
              color: '#8A8787',
              backgroundColor: '#ebd9dd',
              zIndex: '50',
              borderBottomLeftRadius: '7px',
              borderTopRightRadius: '7px',
              fontSize: '17px',
            }}
          />
          <Dropzone onDrop={handleDrop}>
            {({ getRootProps, getInputProps }) => (
              <img
                {...getRootProps()}
                src={URL.createObjectURL(selectedFile)}
                alt={`Selected`}
                style={{
                  width: 'auto',
                  height: '100%',
                }}
              />
            )}
          </Dropzone>
        </div>
      ) : customerDetails?.mobile ? (
        customerFirebasePic ? (
          <div className="h-full w-full  ">
            <Button
              sx={{
                position: 'absolute',
                top: '0',
                right: '0',

                padding: 0,
              }}
            >
              <Close
                onClick={() => {
                  setFirebaseUrl(null);
                  deleteFile(path);
                }}
                style={{
                  position: 'absolute',
                  top: '0',
                  right: '0',
                  color: '#8A8787',
                  backgroundColor: '#ebd9dd',
                  zIndex: '50',
                  borderBottomLeftRadius: '7px',
                  borderTopRightRadius: '7px',
                  fontSize: '17px',
                }}
              />
            </Button>

            <img
              src={customerFirebasePic}
              alt={`Selected`}
              style={{
                width: 'auto',
                height: '100%',
              }}
            />
          </div>
        ) : (
          <>
            <Dropzone onDrop={handleDrop}>
              {({ getRootProps, getInputProps }) => (
                <>
                  <div
                    {...getRootProps()}
                    style={{
                      right: 0,
                      left: 0,
                      zIndex: 100,
                      width: 'auto',
                      height: '100%',
                    }}
                    className={
                      'flex justify-center items-center absolute h-full  '
                    }
                  >
                    <i className="bi bi-person text-ggray  bg-white text-[30px] "></i>
                  </div>
                  <div className="diagonalp-1 w-full h-full "></div>

                  <div className="diagonalp-2 "></div>
                </>
              )}
            </Dropzone>
          </>
        )
      ) : customerFirebasePic ? (
        <div className="h-full w-full  ">
          <Button
            sx={{
              position: 'absolute',
              top: '0',
              right: '0',
              padding: 0,
            }}
          >
            <Close
              onClick={() => {
                setCapturedImage(null);
              }}
              style={{
                position: 'absolute',
                top: '0',
                right: '0',
                color: '#8A8787',
                backgroundColor: '#ebd9dd',
                zIndex: '50',
                borderBottomLeftRadius: '7px',
                borderTopRightRadius: '7px',
                fontSize: '17px',
              }}
            />
          </Button>
          <img
            src={customerFirebasePic}
            alt={`Selected`}
            style={{
              width: 'auto',
              height: '100%',
            }}
          />
        </div>
      ) : (
        <>
          <Dropzone onDrop={handleDrop}>
            {({ getRootProps, getInputProps }) => (
              <>
                <div
                  {...getRootProps()}
                  style={{
                    right: 0,
                    left: 0,
                    zIndex: 100,
                    width: 'auto',
                    height: '100%',
                  }}
                  className={
                    'flex justify-center items-center absolute h-full  '
                  }
                >
                  <i className="bi bi-person text-ggray  bg-white text-[30px] "></i>
                </div>
                <div className="diagonalp-1 w-full h-full "></div>

                <div className="diagonalp-2 "></div>
              </>
            )}
          </Dropzone>
        </>
      )}
    </div>
  );
};

export default ProfilePicFrame;
